import axios from 'axios';
import { SalesPackTabModel, WorkflowJobProcessResultModel } from '@/types';
import AxiosConfiguration from '@/classes/AxiosConfiguration';

const WorkflowJobApiUrl = 'automotive/salespacktab';

export const SalesPackService = {
  async getPreSalesPackAsync(workflowJobId: number): Promise<SalesPackTabModel[]> {
    const response = await AxiosConfiguration.axiosWithoutNotification.get(`${WorkflowJobApiUrl}/presalespack/${workflowJobId}`);
    return response.data;
  },
  async getPostSalesPackAsync(workflowJobId: number): Promise<SalesPackTabModel[]> {
    const response = await AxiosConfiguration.axiosWithoutNotification.get(`${WorkflowJobApiUrl}/postsalespack/${workflowJobId}`);
    return response.data;
  },
  async getPreSalesPackPreviewAsync(workflowJobId: number, documentTypesToInclude: number[]): Promise<string> {
    const response = await axios.post(`${WorkflowJobApiUrl}/previewpresalespack/${workflowJobId}`, [...documentTypesToInclude]);

    return response.data;
  },
  async getPostSalesPackPreviewAsync(workflowJobId: number, documentTypesToInclude: number[]): Promise<string> {
    const response = await axios.post(`${WorkflowJobApiUrl}/previewpostsalespack/${workflowJobId}`, [...documentTypesToInclude]);
    return response.data;
  },
  async sendPreSalesPackForSigningAsync(workflowJobId: number, documentTypesToInclude: number[], useOnFidoAuthentication: boolean): Promise<WorkflowJobProcessResultModel> {
    const response = await axios.post(`${WorkflowJobApiUrl}/SignPreSalesPack/${workflowJobId}/${useOnFidoAuthentication}`, [...documentTypesToInclude]);
    return response.data;
  },
  async sendPostSalesPackForSigningAsync(workflowJobId: number, documentTypesToInclude: number[], useOnFidoAuthentication: boolean): Promise<WorkflowJobProcessResultModel> {
    const response = await axios.post(`${WorkflowJobApiUrl}/SignPostSalesPack/${workflowJobId}/${useOnFidoAuthentication}`, [...documentTypesToInclude]);
    return response.data;
  }
};
